module.exports = __webpack_public_path__ + "img/CRC1_Treg.4baab177.png";